import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setStep} from "../redux/actions/stepActions";
import {getTripById} from "../redux/actions/tripActions";
import {setTransactionClient, setTransactionInfoWidget} from "../redux/actions/transactionActions";

import {Button, Container, Paper} from "@mui/material";
import BookingStepper from "../components/Booking/BookingStepper";
import Grid from "@mui/material/Grid";
import TripSummary from "../components/Booking/Summary/TripSummary";
import ContactForm from "../components/Booking/Information/ContactForm";
import WelcomeCard from "../components/Booking/Information/WelcomeCard";
import * as yup from "yup";

import {
    getNextStep,
    getPreviousStep,
    getStepFromUrl, isDealerSite,
    parseJwt,
    requestApi, requestLoader,
    restartBooking,
    showAlertAutoDis, validateForm,
    isWidget, newRequestApi, bookingActions
} from "../utils/utils";
import {decode} from "js-base64";
import {useIsAuthenticated, useSignIn} from "react-auth-kit";
import GuestBar from "../components/GuestInfo/GuestBar";
import {TripPropTypes} from "../utils/PropTypes/TripPropTypes";
import ObserverDimensions from "../components/ObserverDimensions";

const phoneRegExp = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/i;

let register = yup.object().shape({
    firstname: yup.string().required('The first name is required'),
    lastname: yup.string().required('The last name is required'),
    email: yup.string().email('you need to enter a valid email').required('The email is required'),
    telephone: yup.string().matches(phoneRegExp, 'Phone number is not valid').required('The telephone is required'),
    password: yup.string().required('The password is required'),
    password_confirmation: yup.string().oneOf([yup.ref('password'), null], 'Passwords must match').required('The Confirm password is required'),
    howdidyouhear: yup.string().required('How did you hear about us? Please select a valid option'),
    howdidyouhearother: yup.string().when('howdidyouhear', {
        is: 'Other',
        then: yup.string().required('How did you hear about us? Please type which is that other option'),
        otherwise: yup.string()
    })
});

let login = yup.object().shape({
    email: yup.string().email().required(),
    password: yup.string().required(),
});

let checkFormWidget = yup.object().shape({
	firstname: yup.string().required('The first name is required'),
    lastname: yup.string().required('The last name is required'),
    email: yup.string().email().required(),
	telephone: yup.string().matches(phoneRegExp, 'Phone number is not valid').required('The telephone is required'),
});

const InformationPage = ({history}) => {
    const {id} = useParams();
    const {data: trip} = useSelector(state => state.trip);
    const transactions = useSelector(state => state.transactions);
    const bookingType = useSelector(state => state.bookingType);
    const step = useSelector(state => state.step);
    const dispatch = useDispatch();
    const signIn = useSignIn();
    const isAuth = useIsAuthenticated();
    const prevStep = getPreviousStep(step);
    const nextStep = getNextStep(step);
    const {dealer} = window;
    const {guestInfo} = transactions;
    const [clientName, setClientName] = useState(transactions?.client?.clientName ?? '');
    const totals = useSelector((state) => state.totals);
    const selectedRooms = transactions?.selectedRooms || [];


    const [customer, setCustomer] = useState({
        firstname: '',
        lastname: '',
        email: '',
        telephone: '',
        password: '',
        password_confirmation: '',
        howdidyouhear: '',
        howdidyouhearother: '',
        newsletter: false
    });

	const [guestWidget, setGuestWidget] = useState({
        firstname: '',
        lastname: '',
        email: '',
        telephone: '',
    });

    const [tab, setTab] = useState(0);
    const [loggedIn, setLoggedIn] = useState(false);
    const [userInfo, setUserInfo] = useState({});

    const validateTransactions = () => {
        if (sessionStorage.getItem('transactions')) {
            const transactionsFromSession = JSON.parse(sessionStorage.getItem('transactions'))
            if (parseInt(transactionsFromSession.tripId) !== parseInt(id))
                restartBooking(id);
        }

        if (transactions && transactions.selectedRooms.length < 1)
            restartBooking(id);
    };

    useEffect(() => {
        validateTransactions();
        const stepNum = getStepFromUrl(history.location.pathname);
        dispatch(setStep(stepNum));
    }, []);

    useEffect( async () =>{
        if(isWidget()){
            if(guestWidget.email==='' && guestInfo.email!=='')
                await setGuestWidget(guestInfo);
            dispatch(setTransactionInfoWidget(guestWidget));
            const name = `${guestWidget.firstname} ${guestWidget.lastname}`
            dispatch(setTransactionClient(name, ''));
        }
    },[guestInfo,guestWidget]);

    useEffect(() => {
        if (Object.keys(trip).length === 0)
            dispatch(getTripById(id))
    }, [trip?.TripId]);

    //this has a problem of performance
    useEffect(() => {
        if (localStorage.getItem('user') && !loggedIn) {
            requestApi('/customer/validate', 'POST', {token: localStorage.getItem('user')}, ({data}) => {
                if ('status' in data && data['status'] === 'success' && 'validate' in data) {
                    if (!data['validate'])
                        localStorage.removeItem('user');
                    else {
                        setLoggedIn(true);
                        const {email, firstname, lastname, id, commission, company} = parseJwt(localStorage.getItem('user'));
                        setUserInfo({email, firstname, lastname, id, commission, company});
                    }
                }
            }).catch();
        }
        return () => {
            setLoggedIn(false);
            setUserInfo({});
        };
    }, []);


    useEffect(() => {
        if (loggedIn)
            goToTerms().catch();
    }, [loggedIn]);

    const loginBack = async (values) => {
        const {data} = await requestLoader('booking/loginBack', values);
    };

    const signUpLogin = async (login) => {
        const isDealer = dealer && parseInt(dealer) === 1;
        const url = login || isDealer ? '/customer/login' : '/customer/register';

        try {
            const { data } = await requestApi(url, 'POST', customer);

            const isSuccess = data?.status === 'success';
            if (!isSuccess) {
                const message = data?.message || 'An unexpected error occurred. Please try again.';
                showAlertAutoDis({
                    title: 'Authentication Page',
                    html: message
                });
                return false;
            }

            const tokenParts = data.token.split('.');
            const user = JSON.parse(atob(tokenParts[1]));

            const jwtParams = {
                token: data.token,
                expiresIn: data.expires_in,
                tokenType: data.token_type,
                authState: {
                    id: user.id,
                    firstName: user.firstname,
                    lastName: user.lastname,
                    email: user.email,
                },
            };

            if (isDealerSite()) {
                jwtParams.authState.commission = user.commission;
            }

            if (!signIn(jwtParams)) {
                showAlertAutoDis({
                    title: 'Error',
                    text: `Unable to ${login || isDealer ? 'login' : 'create user'}. Please try again.`
                });
                return false;
            }

            const { email, password } = customer;
            await loginBack({ email, password });
            return true;

        } catch (e) {
            let message = `Unable to ${login || isDealer ? 'login' : 'create user'}.`;
            // Axios error with response data
            if (e?.response?.data?.message) {
                message += ` ${e.response.data.message}`;
            } else if (e?.message) {
                // Generic JS error or Axios fallback
                message += ` ${e.message}`;
            }
            showAlertAutoDis({
                title: 'Error',
                html: message
            });
            return false;
        }
    };


    const goBack = () => {
        history.push(`/booking/${id}${prevStep.url}`);
    };

    const goToTerms = async () => {
        const currentStep = getNextStep(step-1);
        if (loggedIn){
            bookingActions(
                currentStep.label,
                'Next Step',
                `${trip.TripId} - PAX: ${selectedRooms.length} - BookingType: ${bookingType}`,
                trip.locationInfo.location,
                trip.boarddate,
                parseFloat(totals.roomsAmount ?? 0).formatMoney(0))
            history.push(`/booking/${id}${nextStep.url}`);
        }
		else if (await validateForm(tab > 0 || (dealer && parseInt(dealer) === 1) ? login : register, customer)) {
            const success = await signUpLogin(tab);
            if (success){
                bookingActions(
                    currentStep.label,
                    'Next Step',
                    `${trip.TripId} - PAX: ${selectedRooms.length} - BookingType: ${bookingType}`,
                    trip.locationInfo.location,
                    trip.boarddate,
                    parseFloat(totals.roomsAmount ?? 0).formatMoney(0))
                history.push(`/booking/${id}${nextStep.url}`);
            }
        }
    };

	const goToConfirmationWidget = async () => {
        if (await validateForm(checkFormWidget, guestWidget)) {
            // console.log(transactions);
            const {
                data: {
                    status,
                    booking,
                    message,
                    restart
                }
            } = await newRequestApi('/booking/create', 'POST', {transactions, bookingType}, null, true);
            if (status === 'success') {
                return history.push(`/plugin/confirmation/${booking.id}`);
            } else {
                showAlertAutoDis({title: 'Error', text: message}, () => {
                    if (restart)
                        restartBooking(trip.TripId);
                });
            }
        }
    };

    return (
        <div>
            {isAuth() && <GuestBar/>}
            <Container maxWidth="lg">
                <BookingStepper/>
                <div style={{marginTop: 50}}/>
                {trip && Object.keys(trip).length > 0 && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={9}>
							{isWidget() ? 
								<ContactForm widget={true} tab={tab} setTab={setTab} guestWidget={guestWidget} setGuestWidget={setGuestWidget}/>
								:
								loggedIn ? <WelcomeCard userInfo={userInfo}/> : <ContactForm customer={customer} setCustomer={setCustomer} tab={tab} setTab={setTab} guestWidget={guestWidget} setGuestWidget={setGuestWidget}/>
							}
                        </Grid>
                        <Grid item xs={12} sm={12} md={3}>
							<Paper>
								{isWidget() ? 
									<Button color={'primary'} variant={'contained'} fullWidth onClick={goToConfirmationWidget}>
										Next Step
									</Button>:
									<Button color={'primary'} variant={'contained'} fullWidth onClick={goToTerms}>
										Next Step
									</Button>
								}
								<Button color={'secondary'} variant={'contained'} fullWidth onClick={goBack}>
									Go Back to {prevStep.label}
								</Button>
                            </Paper>
                            <TripSummary/>
                        </Grid>
                    </Grid>
                )}
            </Container>
            {isWidget() && <ObserverDimensions/>}
        </div>
    );
};

export default InformationPage;

InformationPage.propTypes = {
    trip: TripPropTypes,
};